import React from 'react';
import { HyperlinkSC } from './hyperlink.styled';
import { THyperlinkVariant } from './hyperlink.types';

interface HyperlinkProps
  extends React.DetailedHTMLProps<
    React.AnchorHTMLAttributes<HTMLAnchorElement>,
    HTMLAnchorElement
  > {
  variant?: THyperlinkVariant;
  as?: string;
}

const VARIANT_MAPPING: Record<THyperlinkVariant, 'body1' | 'body2' | 'body3'> = {
  large: 'body1',
  medium: 'body2',
  small: 'body3',
};

const Hyperlink = (props: HyperlinkProps, ref?: React.Ref<HTMLAnchorElement>) => {
  const { variant = 'large', ...rest } = props;

  return (
    // @ts-ignore
    <HyperlinkSC
      display={VARIANT_MAPPING[variant]}
      variant="link"
      ref={ref as any}
      as={(props.as as any) ?? 'a'}
      {...rest}
    />
  );
};

export default React.forwardRef(Hyperlink);
